<svelte:options customElement="rf-metadata" />

<script>
	import '@digirati/canvas-panel-web-components';
	import { getValue } from '@iiif/helpers';
	import { onMount } from 'svelte';

	// Define multiple props with default values
	let { manifestId = 'name' } = $props();

	let containerElement; // The root element that wraps the slot
	let manifest = $state({});
	const loadManifest = async () => {
		manifest = await window.IIIF_VAULT.load(manifestId);
	};

	onMount(() => {
		loadManifest();
	});
</script>

<section class="rf-metadata" bind:this={containerElement}>
	{#if manifest.type === 'Manifest'}
		<span>Manifest</span>
		{#if manifest.thumbnail && manifest.thumbnail.length}
			<img src={manifest.thumbnail[0].id} alt="" srcset="" />
		{/if}

		<span>{getValue(manifest.label)}</span>
		<!-- <metadata-panel manifest-id={manifestId} variation="list" allow-html="true"></metadata-panel> -->
	{:else if manifest.type === 'Collection'}
		<span>Collection</span>
		<span>{getValue(manifest.label)}</span>
		<!-- <metadata-panel manifest-id={manifestId} allow-html="true"></metadata-panel> -->
	{/if}
</section>

<style lang="scss" global>
	.rf-metadata  {
		display: flex;
		flex-direction: column;
		width: 200px;
		background-color: var(--rf-primary-font-color, #261d2e);
		color: var(--rf-secondary-font-color, #fff);
		border-radius: var(--rf-spacing-xs, 4px);
		padding: var(--rf-spacing-s, 8px);
		margin: var(--rf-spacing-s, 8px);
		font-family: monospace;
	}
	img {
		width: 200px;
	}

	.metadata-key {
		display: block;
	}
</style>
